import { ComponentChildren } from 'preact';
import { Grid } from '../UNSAFE_Grid';
import { Flex } from '../UNSAFE_Flex';
import { Size } from '../utils/UNSAFE_size';

type Props = {
  children: ComponentChildren;
  layout: 'grid' | 'flex';
  gap: Size;
  columns: number;
};

export function BaseCardViewLayout({ children, layout, gap, columns }: Props) {
  if (layout === 'grid') {
    return columns < 1 ? null : (
      <Grid gridTemplateColumns={`repeat(${columns}, 1fr)`} gap={gap}>
        {children}
      </Grid>
    );
  } else {
    return (
      <Flex wrap="wrap" gap={gap}>
        {children}
      </Flex>
    );
  }
}
